<div class="document-list-container dl-card-container">
  @if (displayHeader) {
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <div class="dl-title-bloc">
        {{ labels.Title }}
      </div>
      <div fxLayout="row" fxLayoutAlign="end center" class="dl-header-buttons-container">
        @if (selectedDocsIds.length > 0 && allowDownload) {
          <abc-button
            icon="spindown"
            [stylingMode]="'text'"
            [hint]="labels.Download"
            class="dl-download-multiple-btn"
            (onClick)="downloadMultipleDocument()"
          ></abc-button>
        }
        @if (selectedDocsIds.length > 0 && allowDelete) {
          <abc-button
            icon="trash"
            [stylingMode]="'text'"
            [hint]="labels.Delete"
            class="dl-delete-multiple-btn"
            (onClick)="openDeleteDocumentPopup(null, true)"
          ></abc-button>
        }
        @if (allowChangeLayout) {
          <abc-button
            icon="menu"
            [stylingMode]="'text'"
            [hint]="labels.ListView"
            class="dl-display-list-btn"
            [disabled]="!isGrid"
            (onClick)="displayView(false)"
          ></abc-button>
        }
        @if (allowChangeLayout) {
          <abc-button
            icon="smalliconslayout"
            [stylingMode]="'text'"
            [hint]="labels.DataGrid"
            class="dl-display-grid-btn"
            [disabled]="isGrid"
            (onClick)="displayView(true)"
          ></abc-button>
        }
        @if (allowAdd && parentObjectTypeAndId.size > 0) {
          <abc-button
            [stylingMode]="'text'"
            [hint]="labels.AddDocument"
            class="dl-add-document-btn"
            [icon]="'plus'"
            (onClick)="showAddDocumentPopup()"
          ></abc-button>
        }
      </div>
    </div>
  }
  @if (!isGrid) {
    <div fxLayout="column" fxLayoutGap="5px">
      <abc-common-editors-documents-list
        [allowMultipleSelection]="allowMultipleSelection"
        [allowSearch]="allowSearch"
        [dataSource]="dataSource"
        [(selectedDocumentsIds)]="selectedDocsIds"
        [labels]="labels"
        [customStyle]="customStyle"
        [elementToCheck]="elementToCheck"
        [height]="height"
        [allowSearch]="allowSearch"
        [actionsContextMenu]="actionsContextMenu"
        [isContextMenuVisible]="isContextMenuVisible"
        [specificButtons]="specificContextMenuButton"
        (rowDblClick)="rowDbClick($event)"
        (openActionButtonsMenu)="openActionButtonsMenu($event)"
        (previewDocument)="previewDocument($event)"
        (downloadDocument)="downloadDocument($event)"
        (openDeleteDocumentPopup)="openDeleteDocumentPopup($event)"
        (goToDetails)="goToDetails($event)"
      >
        <ng-content select="#listHeaderOptions"></ng-content>
      </abc-common-editors-documents-list>
    </div>
  }
  @if (isGrid) {
    <div class="dl-gallery-view-style" fxFill>
      <abc-common-editors-documents-grid
        [additionalGridColumns]="additionalGridColumns"
        [allowMultipleSelection]="allowMultipleSelection"
        [allowSearch]="allowSearch"
        [dataSource]="dataSource"
        [(selectedDocumentsIds)]="selectedDocsIds"
        [labels]="labels"
        [height]="height"
        [gridOptions]="gridOptions"
        [actionsContextMenu]="actionsContextMenu"
        [isContextMenuVisible]="isContextMenuVisible"
        [specificButtons]="specificContextMenuButton"
        (rowDblClick)="rowDbClick($event)"
        (openActionButtonsMenu)="openActionButtonsMenu($event)"
        (previewDocument)="previewDocument($event)"
        (downloadDocument)="downloadDocument($event)"
        (openDeleteDocumentPopup)="openDeleteDocumentPopup($event)"
        (goToDetails)="goToDetails($event)"
      ></abc-common-editors-documents-grid>
    </div>
  }

  <abc-context-menu
    #contextMenu
    [showEvent]="'none'"
    [items]="contextMenuItems"
    [position]="{ my: 'top right', at: 'bottom right' }"
    (onHidden)="onContextMenuHidden()"
  >
  </abc-context-menu>

  <abc-popup
    #previewVideoPopup
    (onContentReady)="onDeletePopupShown($event)"
    [height]="'auto'"
    [width]="'auto'"
    [showTitle]="true"
    [title]="labels.ConfirmDelete"
    fxLayout="column"
    fxLayoutAlign="center center"
    [showCloseButton]="true"
  >
    <video width="640" height="360" controls>
      <source [(src)]="videoSrc" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  </abc-popup>

  <abc-popup
    #addDocumentPopup
    (onContentReady)="onAddPopupShown($event)"
    [showTitle]="true"
    [height]="'auto'"
    [width]="widthPopup"
    [position]="'center'"
    [title]="labels.UploadDocument"
    [deferRendering]="'false'"
    [dragEnabled]="dragEnabled"
    class="dl-add-popup"
    (onHidden)="closeDocumentPopup()"
  >
    <div class="dl-add-popup-inputs-container">
      <ng-content> </ng-content>
      @if (!allowMultipleUpload) {
        <abc-text-box
          [readOnly]="false"
          name="name"
          labelMode="floating"
          [label]="labels.FileName"
          [value]="documentName"
          (onValueChanged)="detectDocumentChanges('FileName', $event)"
          class="dl-file-name"
          [width]="'100%'"
        ></abc-text-box>
      }
      @if (!allowMultipleUpload) {
        <abc-text-box
          [readOnly]="true"
          name="size"
          labelMode="floating"
          [label]="labels.Size"
          [value]="documentSize"
          class="dl-file-size"
          [width]="'100%'"
        ></abc-text-box>
      }
      @if (!allowMultipleUpload && fileSizeExceedMaximumSize) {
        <span class="dl-file-size-error">{{ labels.InvalidMaxFileSizeMessage }}</span>
      }
      @if (!allowMultipleUpload) {
        <abc-text-box
          [readOnly]="true"
          name="type"
          [width]="'100%'"
          labelMode="floating"
          [label]="labels.Kind"
          [value]="documentType"
          class="dl-file-type"
        ></abc-text-box>
      }
      <!-- Camera -->
      @if (viewPreference !== 'fileUploader') {
        <div class="dl-video-container">
          <!-- *ngIf="
          !allowMultipleUpload &&
          (viewPreference === 'camera' || (viewPreference === 'cameraAndFileUploader' && allowCamera))
        " -->
          <video
            #videoElement
            id="dl-video"
            class="dl-video"
            [ngClass]="{
              'dl-camera-show':
                viewPreference === 'camera' || (viewPreference === 'cameraAndFileUploader' && allowCamera),
            }"
          ></video>
          <div class="dl-img-container">
            <div class="dl-img-container-img">
              <canvas [id]="canvasId" style="display: none; width: 100%"></canvas>
            </div>
            <div class="dl-img-container-delete">
              @if (!uploadStarted) {
                <div class="dl-img-container-delete-inner">
                  <h2>{{ labels.DeleteImage }}</h2>
                  <img src="assets/images/Delete.svg" (click)="deleteImage()" />
                </div>
              }
            </div>
          </div>
          @if (
            !allowMultipleUpload &&
            (viewPreference === 'camera' || (viewPreference === 'cameraAndFileUploader' && allowCamera)) &&
            videoStream?.id
          ) {
            <abc-button
              [hint]="labels.CaptureImage"
              class="dl-record-btn"
              (onClick)="capture()"
              icon="assets/images/record.svg"
            >
            </abc-button>
          }
        </div>
      }
      <!-------------->

      <!-----Switch button----->

      @if (!allowMultipleUpload && viewPreference === 'cameraAndFileUploader') {
        <div class="dl-custom-switch-container" fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="20px">
          <div (click)="clickSwitchButton()" class="dl-custom-switch">
            @if (allowCamera) {
              <abc-text-box
                stylingMode="filled"
                [rtlEnabled]="false"
                [readOnly]="true"
                width="100"
                [value]="labels.Camera"
                [buttons]="[{ location: 'before', name: 'search', options: { icon: 'assets/images/camera.svg' } }]"
              ></abc-text-box>
            }
            @if (!allowCamera) {
              <abc-text-box
                [rtlEnabled]="true"
                stylingMode="filled"
                [readOnly]="true"
                width="100"
                [value]="labels.Upload"
                [buttons]="[{ location: 'before', name: 'search', options: { icon: 'assets/images/upload.svg' } }]"
              ></abc-text-box>
            }
          </div>
          <!------------>
          @if (
            !allowMultipleUpload &&
            (viewPreference === 'camera' || (viewPreference === 'cameraAndFileUploader' && allowCamera))
          ) {
            <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="dl-camera-upload-btn-container">
              <abc-button
                [disabled]="disableUploadButton || !cameraImageName"
                [text]="labels.UploadImage"
                (onClick)="
                  uploadFile({
                    name: cameraImageName,
                  })
                "
              >
              </abc-button>
              @if (uploadStarted) {
                <div class="dl-spinner"></div>
              }
            </div>
          }
        </div>
      }

      <!-------File uploader buttons-->
      @if (viewPreference === 'fileUploader' || (viewPreference === 'cameraAndFileUploader' && !allowCamera)) {
        <div class="dl-uploader-container" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px">
          <abc-file-uploader
            [class.hide-upload-btn]="selectedDocument"
            #fileUploader
            class="dl-file-uploader"
            [ngClass]="{ 'dl-file-uploader-without-docs-info': !allowMultipleUpload }"
            [accept]="acceptType"
            [multiple]="allowMultipleUpload"
            uploadMode="useButtons"
            [selectButtonText]="labels.UploadDocument"
            [uploadFile]="uploadFile"
            [labelText]="labels.PlaceFileHere"
            [disabled]="disableUploadButton"
            [maxFileSize]="maxFileSizeToUpload"
            (onValueChanged)="onFileUpload($event)"
            [invalidMaxFileSizeMessage]="labels.InvalidMaxFileSizeMessage"
          >
          </abc-file-uploader>
          @if (uploadStarted) {
            <div class="dl-spinner"></div>
          }
        </div>
      }
      <!------------------->
    </div>
  </abc-popup>

  <abc-popup
    #deletePopup
    (onContentReady)="onDeletePopupShown($event)"
    [width]="DeletePopUpWidth"
    [showTitle]="true"
    [title]="labels.ConfirmDelete"
    fxLayout="column"
    fxLayoutAlign="center center"
    [height]="'auto'"
    [showCloseButton]="false"
  >
    <div fxLayout="column" fxLayoutGap="15px" class="dl-delete-popup">
      <div class="dl-delete-msg">{{ labels.DeleteMsg }}</div>
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px">
        <abc-button class="dl-submit-button" [text]="labels.Delete" (onClick)="persistDelete()"></abc-button>
        <abc-button class="dl-cancel-button" [text]="labels.Cancel" (onClick)="closeDeletePopup()"></abc-button>
      </div>
    </div>
  </abc-popup>
</div>
